import { render } from "./UserSidebar.vue?vue&type=template&id=762fad65&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"

import "./UserSidebar.vue?vue&type=style&index=0&id=762fad65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762fad65"]])

export default __exports__